import { render, staticRenderFns } from "./statementItemCompareDetail.vue?vue&type=template&id=27720cb6"
import script from "./statementItemCompareDetail.vue?vue&type=script&lang=js"
export * from "./statementItemCompareDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27720cb6')) {
      api.createRecord('27720cb6', component.options)
    } else {
      api.reload('27720cb6', component.options)
    }
    module.hot.accept("./statementItemCompareDetail.vue?vue&type=template&id=27720cb6", function () {
      api.rerender('27720cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/smf/compare/statementItemCompareDetail.vue"
export default component.exports